import { __rest } from "tslib";
import * as React from 'react';
import { useMemo, useState } from 'react';
import { _AdaptableAgGrid } from '@adaptabletools/adaptable/agGrid';
import { setupFrameworkComponents } from '../setupFrameworkComponents';
import join from '../utils/join';
const getRandomInt = (max) => Math.floor(Math.random() * Math.floor(max));
const AdaptableReact = (_a) => {
    var { adaptableOptions, gridOptions, onAdaptableReady } = _a, props = __rest(_a, ["adaptableOptions", "gridOptions", "onAdaptableReady"]);
    const seedId = useMemo(() => `${getRandomInt(1000)}-${Date.now()}`, []);
    // TODO: not sure this is used anywhere
    const adaptableContainerId = `adaptable-${seedId}`;
    const [adaptableJSXElement, setAdaptableJSXElement] = useState(null);
    const containerRef = useMemo(() => {
        let adaptableApi;
        return (node) => {
            if (node) {
                _AdaptableAgGrid
                    ._initInternal({
                    modules: props.modules,
                    adaptableOptions: Object.assign(Object.assign({}, adaptableOptions), { containerOptions: Object.assign(Object.assign({}, adaptableOptions.containerOptions), { adaptableContainer: node }) }),
                    gridOptions,
                    variant: 'react',
                    renderAgGridFrameworkComponent: props.renderAgGridFrameworkComponent,
                })
                    .then((api) => {
                    adaptableApi = api;
                    //see #no_additional_react_root
                    setAdaptableJSXElement(api.internalApi.getAdaptableJSXElement());
                    if (onAdaptableReady) {
                        adaptableApi.eventApi.on('AdaptableReady', onAdaptableReady);
                    }
                    setupFrameworkComponents(adaptableApi);
                });
            }
            else {
                if (adaptableApi) {
                    adaptableApi.destroy({
                        unmount: true,
                        destroyApi: false,
                    });
                }
                adaptableApi = null;
            }
        };
    }, []);
    return (React.createElement("div", { style: props.style, ref: containerRef, id: adaptableContainerId, className: join(props.className, 'ab__react-wrapper') }, adaptableJSXElement));
};
export default AdaptableReact;
